import React from 'react';
import { Container } from "./styles";

const TextArea = ( props ) => {
    return (
        <Container {...props}/>
    )
}

export default TextArea;
